import {
  COMPANY_LOCALE_FIELD,
  DEFAULT_LOCALE,
  USER_DEFINED_LOCALE_FIELD,
  USER_LOCALE_FIELD,
} from '@config/global-constants';
import { find, get, isEmpty, isNil, map } from 'lodash';
import { IUserSession } from './session.types';

export const updateUserDefineStringLocale = (originalState: IUserSession) => {
  const languagesForCurrentCompany = get(
    originalState,
    ['companyLanguages', originalState.currentCompanyId, 'languages'],
    [],
  );
  // languagesForCurrentCompany still is empty
  if (isEmpty(languagesForCurrentCompany)) return originalState;
  const localesFromCompanyLanguagesSet = new Set(
    map(languagesForCurrentCompany, 'label'),
  );
  const userLocale = get(
    originalState,
    ['i18n', 'locales', USER_LOCALE_FIELD],
    null,
  );
  if (
    !isNil(userLocale) &&
    localesFromCompanyLanguagesSet.has(userLocale) &&
    userLocale !== DEFAULT_LOCALE
  ) {
    return {
      ...originalState,
      i18n: {
        ...(originalState?.i18n ?? {}),
        [USER_DEFINED_LOCALE_FIELD]: userLocale,
      },
    };
  }
  const currentCompany = find(originalState.companies, {
    id: originalState.currentCompanyId,
  });
  const companyLocale = get(
    originalState,
    ['i18n', 'locales', COMPANY_LOCALE_FIELD],
    get(currentCompany, 'preferred_language', null),
  );
  if (
    !isNil(companyLocale) &&
    localesFromCompanyLanguagesSet.has(companyLocale) &&
    companyLocale !== DEFAULT_LOCALE
  ) {
    return {
      ...originalState,
      i18n: {
        ...(originalState?.i18n ?? {}),
        [USER_DEFINED_LOCALE_FIELD]: companyLocale,
      },
    };
  }

  return originalState;
};
